import { lazy } from 'react';

export const BimCalculationRead = lazy(() =>
    import('./BimCalculationRead').then((module) => ({ default: module.BimCalculationRead })),
);
